module.exports = __webpack_public_path__ + "static/media/openbanking-apiled.fe7af7b2.png";